import React from 'react';
import { useTranslation } from "react-i18next";

function BalkhashSightPage(props) 
{
    const { t } = useTranslation();

    return (
        <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
            <h1 className="uk-heading-medium uk-margin-bottom">
                {t("balkhash.title", "Lake Balkhash")}
            </h1>

            <p className="uk-text-lead uk-margin-bottom">
                {t(
                    "balkhash.intro",
                    "Lake Balkhash, one of the largest lakes in Asia, is located in southeastern Kazakhstan. It is unique for having fresh water in its western part and salty water in its eastern part, separated by a narrow strait. The lake is an important ecological and cultural landmark."
                )}
            </p>

            <h2 className="uk-heading-line uk-text-bold">
                <span>{t("balkhash.highlightsTitle", "Highlights")}</span>
            </h2>
            <ul className="uk-list uk-list-bullet uk-margin-bottom">
                <li>{t("balkhash.highlight1", "A rare natural phenomenon: one half of the lake is fresh water, the other half is salty.")}</li>
                <li>{t("balkhash.highlight2", "Rich biodiversity, including numerous fish species and migratory birds.")}</li>
                <li>{t("balkhash.highlight3", "Important for local communities, serving as a source of fishing and irrigation.")}</li>
                <li>{t("balkhash.highlight4", "Surrounded by semi-desert landscapes, offering striking contrasts.")}</li>
            </ul>

            <p className="uk-text uk-text-justify">
                {t(
                    "balkhash.conclusion",
                    "Lake Balkhash is a place of natural and cultural significance, combining ecological diversity with the traditions of the people who have lived along its shores for centuries."
                )}
            </p>
        </div>
    );
}

export default BalkhashSightPage;
